
import "../Popover/Popover.st.css.js";
import "../Foundation/stylable/typography.st.css.js";

import "../Foundation/stylable/colors.st.css.js";
import "../Text/Text.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_Tooltip";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_Tooltip__root","text-small-normal":"wds_1_182_0_StylableTypography__text-small-normal","text-tiny-thin":"wds_1_182_0_StylableTypography__text-tiny-thin","text":"wds_1_182_0_Tooltip__text"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-tooltip-padding-vertical-medium":"--wds-tooltip-padding-vertical-medium","wds-tooltip-padding-horizontal-medium":"--wds-tooltip-padding-horizontal-medium","wds-tooltip-padding-vertical-small":"--wds-tooltip-padding-vertical-small","wds-tooltip-padding-horizontal-small":"--wds-tooltip-padding-horizontal-small","wds-tooltip-background-fill":"--wds-tooltip-background-fill","wds-tooltip-text-fill":"--wds-tooltip-text-fill","wds-tooltip-border-radius":"--wds-tooltip-border-radius"}; 




